import queryString from 'query-string'

export const setLocation = (path: string, queryParams = {}) => {
  window.history.replaceState(
    undefined,
    '',
    `${path}${queryParams && '?' + queryString.stringify(queryParams)}`
  )
}
